import { Form, type InferType, PhoneNumberField, phoneNumberValidation, useForm, yup, yupResolver } from 'form';
import { type I18nScopedKey, type I18nTranslateFunction, useTranslation } from 'i18n';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Link, Typography } from 'ui';

type FeaturesTranslate = I18nTranslateFunction<I18nScopedKey<'features'>>;

const getSchema = (t: FeaturesTranslate) =>
  yup.object().shape({
    phone_number: phoneNumberValidation().required(t('auth.signInPhoneForm.validation.phoneNumberRequired')),
  });

type FormValues = InferType<ReturnType<typeof getSchema>>;

export const SignInPhoneForm = ({
  emailSignInRoute,
  onSubmit,
  isLoading,
}: {
  emailSignInRoute: string;
  onSubmit: (data: FormValues) => void;
  isLoading?: boolean;
}) => {
  const { t } = useTranslation('features');
  const schema = getSchema(t);
  const form = useForm({
    resolver: yupResolver(schema),
  });

  const handleSubmit = (data: FormValues) => {
    onSubmit(data);
  };

  return (
    <Form {...form} onSubmit={handleSubmit} data-testid="sign-in-phone-form">
      <PhoneNumberField
        withFlags
        name="phone_number"
        label={t('auth.signInPhoneForm.labels.phoneNumber')}
        size="medium"
        data-testid="phone-number-field"
        required
        autoFocus
        fullWidth
      />

      <Typography variant="body2" align="right" gutterBottom>
        <Link component={RouterLink} to={emailSignInRoute}>
          {t('auth.signInPhoneForm.actions.signInWithEmail')}
        </Link>
      </Typography>

      <Button type="submit" size="large" fullWidth={true} loading={isLoading}>
        {t('auth.signInPhoneForm.actions.next')}
      </Button>
    </Form>
  );
};
